var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"popover"}},[_c('div',{staticClass:"loading-wrapper",style:({'background-color': _vm.bg})},[_c('svg',{staticClass:"circular",attrs:{"viewBox":"25 25 50 50"}},[_c('circle',{staticClass:"path",attrs:{"cx":"50","cy":"50","r":"20","fill":"none","stroke":_vm.circle_color}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }